import { FaAndroid, FaApple } from 'react-icons/fa'

/**
 * "Free on iPhone and Android" with each platform's logo, so the platform
 * reads at a glance wherever the site names it.
 */
export default function Platforms({
  tone = 'light',
  className = '',
  lead = 'Free on',
  suffix,
}: {
  tone?: 'light' | 'dark'
  className?: string
  lead?: string
  suffix?: string
}) {
  const text = tone === 'dark' ? 'text-cream/80' : 'text-gray-600'
  const strong = tone === 'dark' ? 'text-cream' : 'text-ink'
  const sep = tone === 'dark' ? 'bg-cream/30' : 'bg-ink/20'
  return (
    <p className={`flex flex-wrap items-center gap-x-2 gap-y-1 text-sm ${text} ${className}`}>
      <span>{lead}</span>
      <span className={`inline-flex items-center gap-1 font-semibold ${strong}`}>
        <FaApple className="h-4 w-4" aria-hidden="true" />
        iPhone
      </span>
      <span>and</span>
      <span className={`inline-flex items-center gap-1 font-semibold ${strong}`}>
        <FaAndroid className="h-4 w-4 text-[#3DDC84]" aria-hidden="true" />
        Android
      </span>
      {suffix ? (
        <>
          <span aria-hidden="true" className={`h-1 w-1 rounded-full ${sep}`} />
          <span>{suffix}</span>
        </>
      ) : null}
    </p>
  )
}

/** Inline "iOS and Android" with logos, for use inside running copy. */
export function PlatformNames({ ios = 'iOS', joiner = 'and' }: { ios?: string; joiner?: string }) {
  return (
    <span className="whitespace-nowrap">
      <FaApple className="-mt-0.5 mr-0.5 inline h-[1.05em] w-[1.05em] align-middle" aria-hidden="true" />
      {ios} {joiner}{' '}
      <FaAndroid className="-mt-0.5 mr-0.5 inline h-[1.05em] w-[1.05em] align-middle text-[#3DDC84]" aria-hidden="true" />
      Android
    </span>
  )
}
